import { render } from "./aio-login-color-picker.vue?vue&type=template&id=129f3ad8"
import script from "./aio-login-color-picker.vue?vue&type=script&lang=js"
export * from "./aio-login-color-picker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__